const getTokenFromUrl = (): string | null => {
  const params = new URLSearchParams(window.location.search)
  return params.get('t')
}

export default getTokenFromUrl
